///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';
import { GtthKeyValueDTO, SuccessorSaleCompaniesToAddProjection, UserActivityEventDTO } from '../../generated/shared-types.model';
import { PagedModel } from '../../generated/spring-types.model';
import { SuiUserDTO } from '../../generated/shared-sui-types.model';

export const getUsersPage = createAction('[UsersList] Get Users Page');

export const getUserActivityEventsPage = createAction('[UsersList] Get User Activity Events Page', props<{ selectedUserQueryParams }>());

export const setUserActivityEventsPage = createAction(
    '[UsersList] Set User Activity Events Page',
    props<{ userEventsPage: PagedModel<UserActivityEventDTO> }>()
);

export const getUserActivityEventTypes = createAction('[UsersList] Get User Activity Event Types');

export const setUserActivityEventTypes = createAction(
    '[UsersList] Set User Activity Event Types',
    props<{ userEventTypes: GtthKeyValueDTO[] }>()
);

export const usersActivitySearch = createAction('[UsersList] User Activity Search by Query Params', props<{ queryParams }>());

export const setUsersPage = createAction('[UsersList] Set Users Page', props<{ usersPage: PagedModel<SuiUserDTO> }>());

export const getShowEditButton = createAction('[UsersList] Get Show Edit Button');

export const setShowEditButton = createAction('[UsersList] Set Show Edit Button', props<{ showEditButton: boolean }>());

export const getCurrentAccount = createAction('[UsersList] Get Current Account');

export const setCurrentAccount = createAction('[UsersList] Set Current Account', props<{ currentAccount: SuiUserDTO }>());

export const getSuccessorCompaniesList = createAction('[UsersList] Get Successor Companies List', props<{ saleId: number }>());

export const setSuccessorCompaniesList = createAction(
    '[UsersList] Set Successor Companies List',
    props<{ successorCompaniesList: SuccessorSaleCompaniesToAddProjection[] }>()
);

export const loadPage = createAction('[UsersList] Load Page', props<{ page: number }>());

export const createUser = createAction('[UserManagement] Create User', props<{ newUser: SuiUserDTO }>());

export const modifyUser = createAction('[UserManagement] Modify User', props<{ updatedUser: SuiUserDTO }>());

export const deleteUser = createAction('[UserManagement] Delete User', props<{ id: number; deletedUser: SuiUserDTO }>());

export const deleteSale = createAction('[UserManagement] Delete Sale', props<{ id: number; reassignSaleId: number }>());

export const closeUserDialog = createAction('[UserManagement] Close User Dialog');

export const userDeletionHandling = createAction('[UserManagement] User Deletion Handling');

export const userCreationHandling = createAction('[UserManagement] User Creation Handling');

export const userModificationHandling = createAction('[UserManagement] User Modification Handling');

export const engineerDeletionHandling = createAction('[UserManagement] Engineer Deletion Handling');

export const engineerCreationHandling = createAction('[UserManagement] Engineer Creation Handling');

export const engineerModificationHandling = createAction('[UserManagement] Engineer Modification Handling');

export const FailureResponse = createAction('[UserManagement] Create User Failure');
